//---------------------
//로그인
//---------------------
const loginRouter = [
  {
    path: "/analyze/login",
    name: "analyze-login",
    component: () => import("../views/AnalyzeLogin.vue"),
  },
  {
    path: "/analyze/apple/login",
    name: "analyze-apple/login",
    component: () => import("../views/AnalyzeAppleLogin.vue"),
  },
  {
    path: "/analyze/apple/login/cancel",
    name: "analyze-apple/login/cancel",
    component: () => import("../views/AnalyzeCancelAppleLogin.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/LoginView.vue"),
  },
  // 다방 제휴 진입 (NZSC-3205) — entry_url 이 가리키는 페이지. 토큰 교환 → 세션 → 목적지.
  {
    path: "/dabang/enter",
    name: "dabang-enter",
    component: () => import("../views/DabangEnter.vue"),
  },
  // 다방 주소미정 신청건 직행 (NZSC-3205) — exchange redirect_path 전용. 마이페이지 카드와 동일 세팅 후 확정 퍼널로.
  {
    path: "/dabang/enter/determined",
    name: "dabang-enter-determined",
    component: () => import("../views/DabangDeterminedEnter.vue"),
  },
  // 다방 문의하기 브릿지 (NZSC-3205 task3) — 채널톡 프로필에 report_code 주입 후 상담창 자동 오픈.
  {
    path: "/dabang/support",
    name: "dabang-support",
    component: () => import("../views/DabangSupport.vue"),
  },
];

export default loginRouter;
